import { Props } from '@components/BlockMapper';
import React, { FC } from 'react';

import { SecondaryContentWrapper, StyledBlock } from './styles';

//
//
// Collect options for children of StackedWrapper
//
export { default as StackedSingle } from './StackedSingle';
export { default as StackedStats } from './StackedStats';

//
//
// StackedMaster component children go into
//
const StackedMaster: FC<Props> = (props) => {
  const {
    mainComponent, // most often this should be a BigPictureCta
    secondaryComponents, // most often this should be an array StackedStats or StackedSingle
  } = props;

  return (
    <StyledBlock background="secondaryBg" className="home-page-about-us-content">
      {mainComponent && mainComponent}

      {secondaryComponents && (
        <SecondaryContentWrapper>
          {secondaryComponents.map((component, index) => {
            return <React.Fragment key={index}>{component}</React.Fragment>;
          })}
        </SecondaryContentWrapper>
      )}
    </StyledBlock>
  );
};

export default StackedMaster;
